/**
 * Parses the content of a QR code and returns a URL object if the protocol is supported.
 *
 * @param content - The content string from the QR code to parse.
 * @returns {URL} - A URL object representing the parsed QR code content.
 * @throws {Error} - If the QR code content is invalid or the protocol is not supported.
 */
export function readQRCode(content) {
    const url = new URL(content);
    if (url.hostname === 'app.jebelapp.com') {
        return url;
    }
    throw new Error('The protocol of the QR code is not supported');
}
/**
 * Parses the QR code content and extracts the event access code payload.
 *
 * @param content - The QR code content as a string.
 * @returns An object containing the event ID parsed from the QR code.
 * @throws {Error} If the event ID is not present or if the QR code path is not supported.
 */
export function readEventAccessCodeQRCode(content) {
    const url = readQRCode(content);
    const event = url.searchParams.get('event');
    if (!event) {
        return null;
    }
    if (url.pathname !== '/events/attend') {
        return null;
    }
    return { event };
}
